<template>
	<transition name="fade" mode="out-in" appear>
		<router-view :keep-alive="true"></router-view>
	</transition>
</template>

<script>
    export default {
        name: "manager",
		created(){

            this.$store.dispatch('productless/resetOrder');

			this.$store.dispatch('getPackagingFee');
			this.$store.dispatch('getDeliveryZipCodes');
		},
    }
</script>
